import axios  from 'axios';
import Common from "./common";

const ENDPOINT = process.env.VUE_APP_ENDPOINT ? process.env.VUE_APP_ENDPOINT : 'http://localhost:80';

export const apiList = {
  endpoint                   : ENDPOINT,
  maintenance                : {
    status: '/api/maintenance/status',
  },
  manager                    : {
    login   : '/api/managers/login',
    list    : '/api/managers',
    delete  : '/api/managers/:manager_id',
    detail  : '/api/managers/:manager_id',
    update  : '/api/managers/:manager_id',
    register: '/api/managers',
  },
  user                       : {
    validateDuplicateLogin: '/api/jon/accounts/validate_duplicate_login', // 重複ログインの可能性をチェック
    login                 : '/api/jon/accounts/login',
    logout                : '/api/jon/accounts/logout',
    usage                 : '/api/jon/user/usage',
    requestRegistries     : '/api/jon/registries',
    updateRegistries      : '/api/jon/registries',
    requestRegistrations  : '/api/jon/registrations',
  },
  payment                    : {
    price          : '/api/jon/payments/price',
    priceAfter    : '/api/jon/payments/price_after',
    priceBefore    : '/api/jon/payments/price_before',
    payment_methods: {
      list    : '/api/jon/payment_methods',
      register: '/api/jon/payment_methods',
      detail  : '/api/jon/payment_methods/:gmo_member_id',
      update  : '/api/jon/payment_methods/:gmo_member_id',
      delete  : '/api/jon/payment_methods/:gmo_member_id',
    },
    settings       : {
      list    : '/api/jon/payment_settings',
      detail  : '/api/jon/groups/:group_id/payment_methods',
      register: '/api/jon/groups/:group_id/payment_methods',
      update  : '/api/jon/groups/:group_id/payment_methods',
      delete  : '/api/jon/groups/:group_id/payment_methods',
    },
    card3ds: {
      start : '/api/jon/payment_methods/3ds',
      status: '/api/jon/payment_methods/3ds',
    }
  },
  accounts                   : {
    list              : '/api/jon/accounts',
    detail            : '/api/jon/accounts/:account_id',
    delete            : '/api/jon/accounts/:account_id',
    deregister        : '/api/jon/accounts/:account_id/deregister',
    register          : '/api/jon/accounts/:account_id/register',
    resume            : '/api/jon/accounts/:account_id/resume',
    update            : '/api/jon/accounts/:account_id',
    updatePassword    : '/api/jon/accounts/password',
    updateTService    : '/api/jon/accounts',
    registration      : '/api/jon/accounts',
    setting           : '/api/accounts/setting',
    active            : '/api/jon/accounts/active',
    status            : '/api/accounts/status',
    trial             : '/api/accounts/trial',
    roles             : '/api/accounts/roles',
    duplicateDetection: '/api/accounts/duplicateDetection',
  },
  verify_email               : '/api/verify_email',
  forgot_account             : '/api/forgot_account',
  verify_reset_password_token: '/api/verify_reset_password_token',
  reset_password             : '/api/reset_password',
  application                : {
    trial   : '/api/application',
    contract: '/api/application/contract',
  },
  terminate                  : '/api/terminate',
  terminated                 : '/api/terminated',
  trial                      : {
    initial_info: '/api/trial_info',
    latest_info : '/api/trial_latest_info',
    current_info: '/api/trial_current_info',
  },
  history                    : {
    geocodings: '/api/history/geocodings',
    maps      : '/api/history/maps',
    chibans   : '/api/history/chibans',
    rosens    : '/api/history/rosens',
    logs      : '/api/histories',
    report    : '/api/histories/report',
    download  : '/api/histories/download',
  },
  information                : {
    information   : '/api/informations',
    publication   : '/api/informations/publication',
    detail        : '/api/informations/:information_id',
    update        : '/api/informations/:information_id',
    registry      : '/api/informations',
    delete        : '/api/informations/:information_id',
    doNotShowAgain: '/api/informations/doNotShowAgain',
  },
  faq                        : {
    reorder : '/api/faqs/reorder',
    list    : '/api/faqs',
    detail  : '/api/faqs/:id',
    register: '/api/faqs',
    update  : '/api/faqs/:id',
    delete  : '/api/faqs/:id',
  },
  faqCategory                : {
    reorder : '/api/faqs/categories/reorder',
    detail  : '/api/faqs/categories/:id',
    register: '/api/faqs/categories',
    update  : '/api/faqs/categories/:id',
    delete  : '/api/faqs/categories/:id',
  },
  jon                        : {
    groups                         : {
      list    : '/api/jon/groups',
      detail  : '/api/jon/groups/:group_id',
      delete  : '/api/jon/groups/:group_id',
      register: '/api/jon/groups',
      update  : '/api/jon/groups/:group_id',
    },
    accounts                       : {
      search: '/api/jon/admin/accounts/search',
      auth  : '/api/jon/accounts/auth',
      role  : '/api/jon/accounts/role',
      update: '/api/jon/accounts',
    },
    billings                       : {
      billings                 : '/api/jon/billings',
      detail                   : '/api/jon/corporations/:corporation_id/billings/:id',
      downloadAllInvoices      : '/api/jon/billings/download',
      downloadAllInvoicesByMail: '/api/jon/billings/download/mailed',
      downloadFile             : '/api/jon/billings/download/file',
    },
    billing_email_controls         : {
      send   : '/api/jon/billing_email_controls/:billing_month/send',
      detail : '/api/jon/billing_email_controls/:billing_month',
      hold   : '/api/jon/billing_email_controls/:billing_month/hold',
      release: '/api/jon/billing_email_controls/:billing_month/release',
    },
    user_billings                  : {
      billings: '/api/jon/user/billings',
      detail  : '/api/jon/user/billings/:id',
    },
    corporations                   : {
      corporations: '/api/jon/corporations',
      groups      : {
        list: '/api/jon/corporations/:corporation_id/groups',
      }
    },
    point                          : '/api/jon/point',
    na_layer                       : '/api/jon/na_layer',
    data_layer                     : '/api/jon/data_layer',
    coordinate_info                : '/api/jon/coordinate_info',
    in_na                          : '/api/jon/in_na',
    chiban                         : '/api/jon/chiban',
    rosen                          : '/api/jon/rosen',
    registries                     : '/api/jon/registries',
    activation                     : '/api/jon/activation',
    parcel_number                  : '/api/jon/parcel_number',
    parcel_to_building_number      : '/api/jon/parcel_to_building_number',
    parcel_and_building_to_incident: '/api/jon/parcel_and_building_to_incident',
    retry_registration             : '/api/jon/registration/retry',
    registration                   : '/api/jon/registration',
    registration_status            : '/api/jon/registration/status',
    detect_duplicate_request       : '/api/jon/detect_duplicate_request',
    confirm_available              : '/api/jon/confirm_available',
    locating                       : '/api/jon/locating',
    download                       : '/api/jon/download',
    downloadPdfs                   : '/api/jon/download/pdfs',
  },
  upload: {
    image: '/api/upload',
  },
  download: {
    file: '/api/download',
  },
};

/**
 * Auth failed status
 */
const AUTH_FAILED = 401;

/**
 * Maintenance mode
 * @type {number}
 */
const MAINTENANCE_FAILED = 503;

/**
 * Map login url
 */
const MAP_LOGIN = '/map/login';

/**
 * Manager login url
 */
const MANAGER_LOGIN = '/admin/login';

export const apiClient = axios.create({
  baseURL        : ENDPOINT,
  withCredentials: true,
});
apiClient.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && AUTH_FAILED === error.response.status) {
    return Promise.reject({message: Common.messages.account.authFailed});
  } else if (error.response && MAINTENANCE_FAILED === error.response.status) {
    return Promise.reject({message: Common.messages.errorMaintenanceMode});
  }
  return Promise.reject({message: Common.messages.serverError});
});

export const apiClientWithUserToken = axios.create({
  baseURL        : ENDPOINT,
  withCredentials: true,
});
// Add a request interceptor
apiClientWithUserToken.interceptors.request.use(function (config) {
  const accessToken = localStorage.getItem(Common.localStorageKeys.user.accessToken);
  config.headers    = {
    'X-Auth-Token': accessToken,
  };
  return config;
});
apiClientWithUserToken.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && AUTH_FAILED === error.response.status) {
    // Log out
    const accessTokenExpireIn = localStorage.getItem(Common.localStorageKeys.user.accessTokenExpireIn);
    if (accessTokenExpireIn === null) {
      return Promise.reject();
    }

    const isExpiredToken = Common.isExpiredToken(accessTokenExpireIn);
    localStorage.removeItem(Common.localStorageKeys.user.accessToken);
    localStorage.removeItem(Common.localStorageKeys.user.accessTokenExpireIn);
    localStorage.removeItem(Common.localStorageKeys.user.auth);
    localStorage.setItem(Common.localStorageKeys.user.errorForceLogin, isExpiredToken
      ? Common.messages.errorTokenExpired
      : Common.messages.errorDuplicateLogin);
    // Redirect to map login
    window.location = MAP_LOGIN;
    return Promise.reject();
  } else if (error.response && MAINTENANCE_FAILED === error.response.status) {
    // Log out
    localStorage.removeItem(Common.localStorageKeys.user.accessToken);
    localStorage.removeItem(Common.localStorageKeys.user.accessTokenExpireIn);
    localStorage.removeItem(Common.localStorageKeys.user.auth);
    localStorage.setItem(Common.localStorageKeys.user.errorForceLogin, Common.messages.errorMaintenanceMode);
    // Redirect to map login
    window.location = MAP_LOGIN;
    return Promise.reject();
  } else {
    return Promise.reject(error);
  }
});

export const apiClientWithManagerToken = axios.create({
  baseURL        : ENDPOINT,
  withCredentials: true,
});
// Add a request interceptor
apiClientWithManagerToken.interceptors.request.use(function (config) {
  const accessToken = localStorage.getItem(Common.localStorageKeys.admin.accessToken);
  config.headers    = {
    'X-Manager-Auth-Token': accessToken,
  };
  return config;
});
apiClientWithManagerToken.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && AUTH_FAILED === error.response.status) {
    // Log out
    const accessTokenExpireIn = localStorage.getItem(Common.localStorageKeys.admin.accessTokenExpireIn);
    if (accessTokenExpireIn === null) {
      return Promise.reject();
    }

    const isExpiredToken = Common.isExpiredToken(accessTokenExpireIn);
    localStorage.removeItem(Common.localStorageKeys.admin.accessToken);
    localStorage.removeItem(Common.localStorageKeys.admin.accessTokenExpireIn);
    localStorage.setItem(Common.localStorageKeys.admin.errorForceLogin, isExpiredToken
      ? Common.messages.errorTokenExpired
      : Common.messages.errorDuplicateLogin);
    // Redirect to admin login
    window.location = MANAGER_LOGIN;
    return Promise.reject();
  } else if (error.response && MAINTENANCE_FAILED === error.response.status) {
    // Log out
    localStorage.removeItem(Common.localStorageKeys.admin.accessToken);
    localStorage.removeItem(Common.localStorageKeys.admin.accessTokenExpireIn);
    localStorage.setItem(Common.localStorageKeys.admin.errorForceLogin, Common.messages.errorMaintenanceMode);
    // Redirect to map login
    window.location = MANAGER_LOGIN;
    return Promise.reject();
  } else {
    return Promise.reject(error);
  }
});


export const apiTool = {
  /**
   * 通信をキャンセルするためのトークンを発行
   *
   * @returns {CancelTokenSource}
   */
  cancelToken() {
    const CancelToken = axios.CancelToken;
    return CancelToken.source();
  },
  /**
   * エラー内容がキャンセルで発生したものか
   *
   * @param value
   * @returns {boolean}
   */
  isCancel(value) {
    return axios.isCancel(value);
  }
};
